import React, { FC, Fragment, useEffect } from 'react';
import Label from '../Label/Label';
import Button from '../Button';
import Tooltip from '../Tooltip';
import usePdpBuilder from './useProductBuilder';
import { RootState } from '../../reducers/RootReducer';
import { connect, ConnectedProps } from 'react-redux';
import {
  setBackDiamondDetails,
  setBackFromDiamond,
  setBandTabIndex,
  setExclusionOption,
  setInitialOption,
  setIsEngraving,
  setIsHandLoaded,
  setJourney,
  setOptionsData,
  setOptionsFail,
  setOptionsLoading,
  setPriceLoading,
  setRemoveRingOption,
  setRingExtraData,
  setRingOptions,
  setRingPrice,
  setRingPriceError,
  setSelectedDiamondData,
  setSelectedDiamondFail,
  setSelectedDiamondLoading,
  setSelectedRingDetails,
  setShowCrownMetal
} from '../../action/RingAction';
import { setFooterToggle, setIsShowFooter, setRedirectEditPage, setStyleID } from '../../action/FooterAction';
import { setAfterRingOptions, setFilter } from '../../action/FilterAction';
import {
  setBackToSelectDiamondPage,
  setDiamondDetailsFail,
  setDiamondDetailsLoading,
  setDiamondDetailsSuccess
} from '../../action/DiamondAction';
import { set3DImageLoading, set3DImageSuccess } from '../../action/CartAction';
import Loader from '../Loader/Loader';
import DiamondSizeSlider from '../DiamondSizeSlider';
import { centerDiamondSizeType, DiamondSizeValueType, PDPBuilderType, PropsFromScreenManager } from '../../types';
import FloatingLabel from '../FloatingLabel/floatingLabel';
import { changeBackClick, setHeaderTabDefault, setSettingTabIconTrue } from '../../action/HeaderAction';
import { SetTooltipDataError, setTooltipDataLoading, SetTooltipDataSuccess } from '../../action/TooltipAction';
import classes from './PdpBuilder.module.css';
import { ToLocalStringConvert } from '../../Utils/toLocalStringConvert';
import { DiamondShapeContent, PDPColorImage, SideStones, weddingButton } from '../../Utils/commonData';
import { setExpandedRow, toggleScrollTop } from '../../action/TableAction';
import Icon from '../Icons';
import {
  setInitialStartWithSettingData,
  setResetStartWithSettingFilter,
  setScrollTop
} from '../../action/StartWithSettingFilterAction';
import {
  Beadset,
  CarmenCathedral,
  Channel,
  DeliaTwist,
  DoubleHalo,
  EmmaSplit,
  HiddenHalo,
  NellKnifeEdge,
  ParkerClassic,
  Pave,
  Plain,
  Prong,
  ProngCrown,
  SingleHalo,
  StellaThreeStone
} from '../Images';
import { buildYourOwnValue } from '../../Utils/findNearestCaratValue';
import { getCenterDiamondSize } from '../../Utils/getExclusionDiamondSize';
import { getBuildSearchParams } from "../../Utils/general";
import CONSTANTS from "../../constant/general";
import {
  toConfigOptionSlug,
  toConfigValueSlug,
  toCaratValue,
  toTrackingProductName,
  toMetalOptionValueSlug,
  toRingSizeValue,
  toMatchingBandValue
} from "../../constant/trackingContract";

const mapStateToProps = (state: RootState) => ({
  ring:          state.ring,
  diamond:       state.diamond,
  header:        state.header,
  tooltip:       state.tooltip,
  stateManager:  state.stateManager,
  stateManger:   state.stateManager,
  footer:        state.footer,
  settingFilter: state.settingFilter,
  table:         state.table,
  filter:        state.filter,
});

const mapDispatchToProps = {
  setRingOptions,
  setOptionsLoading,
  setOptionsData,
  setOptionsFail,
  setSelectedDiamondLoading,
  setSelectedDiamondData,
  setSelectedDiamondFail,
  setSelectedRingDetails,
  setFooterToggle,
  setFilter,
  setDiamondDetailsLoading,
  setDiamondDetailsFail,
  setDiamondDetailsSuccess,
  setInitialOption,
  setBackDiamondDetails,
  setSettingTabIconTrue,
  setHeaderTabDefault,
  setAfterRingOptions,
  setRemoveRingOption,
  setBandTabIndex,
  SetTooltipDataSuccess,
  setTooltipDataLoading,
  SetTooltipDataError,
  setIsShowFooter,
  setStyleID,
  setRedirectEditPage,
  setPriceLoading,
  setRingPrice,
  setRingPriceError,
  setExpandedRow,
  set3DImageLoading,
  set3DImageSuccess,
  setRingExtraData,
  setInitialStartWithSettingData,
  setResetStartWithSettingFilter,
  setBackToSelectDiamondPage,
  toggleScrollTop,
  setExclusionOption,
  setIsHandLoaded,
  changeBackClick,
  setIsEngraving,
  setScrollTop,
  setJourney,
  setBackFromDiamond,
  setShowCrownMetal
};
const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRingRedux = ConnectedProps<typeof connector>;

const PdpBuilder: FC<PDPBuilderType & PropsFromScreenManager> = (props) => {
  const {
    ring,
    diamond,
    footer,
    setBackDiamondDetails,
    setHeaderTabDefault,
    setRingOptions,
    setInitialOption,
    setBackToSelectDiamondPage,
    setIsShowFooter,
    instanceData: { screenManager },
    toggleScrollTop,
    setSettingTabIconTrue,
    setIsEngraving,
    setScrollTop,
    activeIndex,
    setShowCrownMetal,
  } = props;
  const showCrownMetal = ring.showCrownMetal;
  const {
    productName,
    handleAllOptions,
    styleId,
    handleSelectSetting,
    fieldValidation,
    isEditableRingOptions,
    rpid,
    uuid,
    builder_mode,
    weddingBand,
    ringPrice,
    handleWeddingBand,
    setShowError,
    isDisabledOption,
    handleReviewClick,
    isStuds,
    isSettingPage,
    isListingRing,
    isLoading
  } = usePdpBuilder(props, showCrownMetal);

  const hadWeights = React.useRef({ ring: false, bands: false });
  if (!ring.isPriceLoading) {
    hadWeights.current = { ring: !!ring.ringPrice.ring_tcw, bands: !!ring.ringPrice.bands_tcw };
  }
  const showRingWeight = ring.isPriceLoading ? hadWeights.current.ring : !!ring.ringPrice.ring_tcw;
  const showBandsWeight = ring.isPriceLoading ? hadWeights.current.bands : !!ring.ringPrice.bands_tcw;

  const { Metal, Color, Crown_Metal, Crown_Color } = ring.options || {};
  useEffect(() => {
    if (!ring.extraData.customisation_allowed || !Crown_Metal || !Crown_Color) return;
    if (Crown_Metal !== Metal || Crown_Color !== Color) {
      setShowCrownMetal(true);
    }
  }, [ Metal, Color, Crown_Metal, Crown_Color, ring.extraData.customisation_allowed, setShowCrownMetal ]);

  if (ring.isLoading || diamond.isLoading || ring.isSelectedDiamondLoading || !footer.styleID) {
    return (
      <div className={"loading-details"}>
        <Loader position="absolute"/>
      </div>
    );
  }
  if (ring.error) {
    return <div>Error</div>;
  }

  const pdpImages: { [key: string]: string } = {
    PKR: ParkerClassic,
    EMS: EmmaSplit,
    CCD: CarmenCathedral,
    DLT: DeliaTwist,
    NKE: NellKnifeEdge,
    STS: StellaThreeStone,
    PRG: Prong,
    BDS: Beadset,
    HHL: HiddenHalo,
    SHL: SingleHalo,
    DHL: DoubleHalo,
    PLN: Plain,
    PVE: Pave,
    CNL: Channel,
    CLP: ProngCrown,
  };

  const getOptionName = (key: string, code: string | undefined) => {
    const options = ring.optionsData[key] as { Code: string; Name: string }[] | undefined;
    return options?.find((option) => option.Code === code)?.Name ?? code;
  };
  const getTrackedOptionValue = (key: string, nameOrCode: string | undefined): string => {
    if ([ 'Metal_Color', 'Crown_Metal_Color' ].includes(key)) return toMetalOptionValueSlug(nameOrCode);
    if (key === 'Ring_Size') return toRingSizeValue(nameOrCode);
    if (key === 'Center_Diamond_Size') return toCaratValue(nameOrCode);
    if (key === 'Wedding_Band') return toMatchingBandValue(nameOrCode, styleId);
    return toConfigValueSlug(nameOrCode);
  };
  const getOptionValueSlug = (key: string, code: string | undefined) =>
    getTrackedOptionValue(key, getOptionName(key, code));

  const configPayload = {
    diamondShape: getOptionValueSlug('Diamond_Shape', ring.options.Diamond_Shape),
    diamondType: getOptionValueSlug('Diamond_Type', ring.options.Diamond_Type),
    centerDiamondSize: toCaratValue(ring.options.Center_Diamond_Size),
    metal: getOptionValueSlug('Metal_Color', `${ring.options.Metal}_${ring.options.Color}`),
    crownMetal: getOptionValueSlug('Crown_Metal_Color', `${ring.options.Crown_Metal}_${ring.options.Crown_Color}`),
    ringSize: getOptionValueSlug('Ring_Size', ring.options.Ring_Size as string | undefined),
    matchingBand: toMatchingBandValue(ring.options.Wedding_Band as string | undefined, styleId),
  };

  const trackingName = toTrackingProductName(
    ring.selectedRingDetails.Ring_Style as string | undefined,
    diamond.details as { shape?: unknown; color?: unknown; clarity?: unknown }
  );

  const ctaPayload = isStuds
    ? JSON.stringify({ name: trackingName, price: +ringPrice, components: { setting: styleId } })
    : JSON.stringify({ id: styleId, name: trackingName, price: +ringPrice, url: window.location.href, config: configPayload });

  const handleMatchingBand = (index: number, Code: string) => {
    setShowError(false);
    isEditableRingOptions.current = false;
    window.postMessage({
      action: index === 0 ? "ChangeLeftBandColor" : "ChangeRightBandColor",
      value:  Code?.split("_")[1],
    });
    setRingOptions(
      index === 0
        ? `${ring.options["Wedding_Band"]}_First_Band`
        : `${ring.options["Wedding_Band"]}_Second_Band`,
      Code?.split("_")[1]
    );
    setRingOptions(
      index === 0
        ? `${ring.options["Wedding_Band"]}_First_Metal_Band`
        : `${ring.options["Wedding_Band"]}_Second_Metal_Band`,
      Code
    );
  };
  return (
    <>
      <div className={`${classes.root} rb-track-config`} data-rb-page="setting-config" data-rb-setting-id={styleId}>
        <div className={classes.stickys}>
          <div className={`${classes.title_wrap} ${isStuds ? classes.title_wrap_baseline : ''}`}>
            <h1 className={classes.title}>{productName}</h1>
            {/*{ring.isPriceLoading ? <div>Loading...</div> : <div className={classes.price}>${ToLocalStringConvert(+(diamond.details.b2c_price ? diamond.details.b2c_price : 0) + +ring.ringPrice)}</div>}*/}

                      <div className={`${classes.price} ${isStuds ? classes.priceNoLabel : ''}`}>
                        {!isStuds && <span className={classes.price_title}>Setting Price:</span>}
                        <span className={classes.pricing}>{ring.isPriceLoading || !ringPrice || ringPrice <= 0 ? 'Loading...' : `$${ToLocalStringConvert(+ringPrice)}`}</span>
                      </div>


                </div>
                {showRingWeight || showBandsWeight ?
                    <ul className={classes.subtitle}>
                        {showRingWeight ? <li>{isStuds ? "Minimum Earring Pair Total Weight:" : "Minimum Setting Total Weight:"} {ring.isPriceLoading ? 'Loading...' : `${ring.ringPrice.ring_tcw} ct.`}</li> : null}
                        {!isStuds && ring.options["Wedding_Band"] !== weddingBand[0] && showBandsWeight ?
                        <li>Minimum {ring.options["Wedding_Band"] === weddingBand[1] ? 'Band' : 'Bands'} Total
                            Weight: {ring.isPriceLoading ? 'Loading...' : `${ring.ringPrice.bands_tcw.toFixed(2)} ct.`}</li> : null}
                    </ul>:''
                }
            </div>
            <div className={classes.details}>
                {/*{ring.extraData.Description ? <p className={classes.desc}>{ring.extraData.Description}</p> :''}*/}
                {((diamond.details && diamond.details.carat && +diamond.details.carat > buildYourOwnValue[getCenterDiamondSize(ring.exclusionOption)]) || (ring.options.Center_Diamond_Size && ring.options.Center_Diamond_Size === "300")) && !isStuds ? <p className={classes.desc}>The preview image represents diamonds up to {buildYourOwnValue[getCenterDiamondSize(ring.exclusionOption)]} carats. Larger sizes will not be shown to scale.</p> : ''}
                {Object.entries(ring.optionsData).filter(([key,value]) =>!Object.keys(ring.selectedDiamondOptions).includes(key)).map(([key,value],index)=>{
                    if(key === 'Center_Diamond_Size') {
                      const DiamondSizeValue =  (value as DiamondSizeValueType[]).filter(option => !ring.exclusionOption.includes(option.Code));
                        const marks : { [key: number]: string } = DiamondSizeValue.reduce((acc, val, index) => {
                            const step =  Math.round(100 / (DiamondSizeValue.length)); // Calculate the step size
                            const key = step * index;
                            return { ...acc, [key]: val.Name };
                        }, {});
                        const fIndex = (DiamondSizeValue as any[]).map((v) => v.Code).indexOf(ring.options[key]);
                        const currentSizeCode = DiamondSizeValue[fIndex]?.Code ?? (ring.options[key] as string);
                        return (
                            <div className={`${classes.items} hk_${key.toLowerCase()}`} key={index}>
                                <Label text={isStuds ? 'Center Diamond Total Carat Weight (Pair)': key.replaceAll('_',' ')} page={'pdpBuilder'}>
                                 {/*shapeText={ring.options[key as keyof typeof ring.options]}*/}
                                    <div
                                        className={`${classes.wrapper} rb-track-config-option`}
                                        data-rb-option={toConfigOptionSlug(key)}
                                        data-rb-value={toCaratValue(currentSizeCode)}
                                    >
                                        <DiamondSizeSlider
                                            marks={marks}
                                            handleAllOptions={handleAllOptions}
                                            shapeKey={key}
                                            fIndex={fIndex}
                                            allValue={value as centerDiamondSizeType[]}
                                        />
                                    </div>
                                </Label>
                            </div>
                        )
                    }else {
                        return (
                            <Fragment key={index}>{(Array.isArray(value) && value.length > 1) && (key !== 'Crown_Metal_Color' || showCrownMetal) ?
                              <div className={`${classes.items} hk_${key.toLowerCase()} ${key.toLowerCase() === "color" ? `head_color` : '' }`}>
                                {/* shapeText={ring.options[key as keyof typeof ring.options]} */}
                                <Label
                                  text={key === 'Metal_Color' ? 'Metal' : key === 'Crown_Metal_Color' ? 'Crown Metal' : key.replaceAll('_', ' ')}
                                  page={'pdpBuilder'}>
                                    <div className={classes.wrapper}>
                                      {(value as any[]).filter(value => key === 'Crown_Metal_Color' ? (ring.options.Metal !== 'PT' ? (ring.options.Metal === value.Code?.split('_')[0] || ['PT_WG'].includes(value.Code)) : ['18_YG', '18_RG', 'PT_WG'].includes(value.Code)) : value).map((v, index) => {
                                            const isDiamondShape = DiamondShapeContent.find((shape)=>shape.code === v.Code);
                                            const isDisabled = !!Object.keys(ring.selectedDiamondOptions).find(diamond => diamond === key) || (['Jenny Packham'].includes(ring.extraData.Label) && (key === 'Metal_Color' || key === 'Crown_Metal_Color') && v.Code.match('14'));
                                            const disabledEarringBack = ring.options.Metal === "PT"  && isStuds && key === "Earring_Back" && v.Code === "GRD";
                                            return(
                                                <Fragment key={index}>
                                                  <Button
                                                    key={index}
                                                    isDisabled={disabledEarringBack || isDisabled || isDisabledOption || (key === "Diamond_Type" && !["Generic"].includes(ring.extraData.Label)) || ring.exclusionOption.includes(v.Code)}
                                                    buttonType={ring.options && ['Metal_Color', 'Crown_Metal_Color'].includes(key) ? (((`${ring.options['Metal']}_${ring.options['Color']}` === v.Code) && key === 'Metal_Color') || (((`${ring.options['Crown_Metal']}_${ring.options['Crown_Color']}` === v.Code) && key === 'Crown_Metal_Color')) ? 'active' : undefined) : (ring.options[key as keyof typeof ring.options] === v.Code ? 'active' : undefined)}
                                                    type="button"
                                                    name={key}
                                                    code={v.Code}
                                                    className = {`${classes.button} hk_${key.toLowerCase()}_button rb-track-config-option`}
                                                    data-rb-option={toConfigOptionSlug(key)}
                                                    data-rb-value={getTrackedOptionValue(key, v.Name)}
                                                    onClick={() => {
                                                        if (ring.options[key] !== v.Code) {
                                                            handleAllOptions(key, v);
                                                        }
                                                    }}
                                                >
                                                    {(v.image_name && !isDiamondShape) && (
                                                        <img
                                                            className={classes.swatchImg}
                                                            src={pdpImages[v.Code]}
                                                            alt={v.icon || v.Icon}
                                                        />
                                                    )}
                                                    {
                                                        isDiamondShape && (
                                                            <img
                                                                className={classes.swatchImg}
                                                                src={isDiamondShape.imgPath}
                                                                alt={v.icon || v.Icon}
                                                            />
                                                        )
                                                    }
                                                    {PDPColorImage[v.Code?.split('_')[1]] && (
                                                        <img
                                                            className={`${classes.swatchImg} ${classes.swatchImgColor}`}
                                                            src={PDPColorImage[v.Code?.split('_')[1]]}
                                                            alt={v.Name}
                                                        />
                                                    )}
                                                    {SideStones[v.Code] && (
                                                            <img
                                                                style={{ width: '16px' }}
                                                                src={SideStones[v.Code]}
                                                                alt={v.Name}
                                                            />
                                                        )
                                                    }
                                                    <span className={classes.swatchText}>{key === "Side_Stones" && v.Code?.toUpperCase() === "DIA" ? ring.options["Diamond_Type"] === "GNU" ? `Natural ${v.Name}` : `Lab Grown ${v.Name}` :v.Name}</span>
                                                  </Button>
                                                </Fragment>
                                            )
                                      })}
                                    </div>
                                </Label>
                                {
                                    fieldValidation.length > 0 &&
                                        fieldValidation.includes(key)?
                                        (<span className={classes.error}><Icon name={'hk_info_circle'} />{`Please select your ${key.replace('_', ' ')}.`}</span>)
                                        : null
                                }
                            </div>: null}
                              {key === 'Metal_Color' && Array.isArray(ring.optionsData['Crown_Metal_Color']) ? (
                                <div className={`${classes.items} ${classes.crownMetalToggle}`}>
                                  <Label
                                    text={"Choose a different crown metal?"}
                                    page={'pdpBuilder'}
                                    startSideContent={
                                      <label className={`${classes.toggleSwitch} ${classes.toggleSwitchStart}`}>
                                        <input
                                          type="checkbox"
                                          checked={showCrownMetal}
                                          onChange={(e) => {
                                            const isOn = e.target.checked;
                                            setShowCrownMetal(isOn);
                                            handleAllOptions('Crown_Metal_Color', {
                                              Code: `${ring.options.Metal}_${ring.options.Color}`,
                                            });
                                          }}
                                        />
                                        <span className={classes.toggleSlider}/>
                                      </label>
                                    }
                                    endSideContent={
                                      <Tooltip title={'Why mix metals?'} page={'pdpBuilder'}/>
                                    }
                                  >
                                    {null}
                                  </Label>
                                </div>
                              ) : null}
                            </Fragment>
                        )
                    }
                })}
              {
                !isStuds ? <div className={`${classes.items}`}>
                  <Label text={`Engraving`} optionsText={<span className="ml-1.5 text-sm font-semibold text-[#909090] italic">(Complimentary)</span>}>
                    <FloatingLabel
                        label={"Your Message"}
                        labelId={`Engraving`}
                        maxLength={18}
                        keyName={"Engraving"}
                        setRingOptions={setRingOptions}
                        value={ring.options["Engraving"]}
                        setIsEngraving={setIsEngraving}
                        options={ring.options}
                        activeIndex={activeIndex}
                        isHandView={ring.isHandLoaded}
                        validationRegex={/^[a-zA-Z0-9 !@#$%^&*(),.<>?;:"'+=\-\/\\]*$/}
                        validationErrorMessage={"Only English letters, numbers, and special characters are allowed."}
                    />
                  </Label>
                </div> : null
              }

          {(ring.extraData.Bands !== 0) && !isStuds ? <>
            <div className={`${classes.items} band_options`}>
              <Label text={"Matching Band"} optionsText={<span className={classes.smallChar}>(s)</span>}
                     page={'pdpBuilder'}>
                <div className={classes.wrapper}>
                  {weddingBand.map((band, index) => {
                    return (
                      <Button type={'button'} code={String(index)} key={index}
                              buttonType={ring.options["Wedding_Band"] === band ? "active" : undefined}
                              className={`${classes.button} rb-track-config-option`}
                              data-rb-option="matching-band"
                              data-rb-value={toMatchingBandValue(band, styleId)}
                              onClick={() => handleWeddingBand(index, band)}>
                        <span className={classes.swatchText}>{band}</span>
                      </Button>
                    )
                  })}
                </div>
              </Label>
            </div>
            {Array.from(Array(ring.tabIndex)).map((bandIndex, i) => {
              return (
                <React.Fragment key={i}>
                  <div
                    className={`${classes.items} ${i === 0 ? 'left_band_color' : 'right_band_color'} hk_metal_color`}>
                    <Label text={`${i === 0 ? 'First' : 'Second'} Band Metal`} page={'pdpBuilder'}>
                      <div className={classes.wrapper}>
                        {weddingButton.map((band, index) => {

                          return (
                            <Fragment
                              key={index}>{!(ring.options.Metal !== "PT" ? !((ring.options[i === 0 ? `${ring.options["Wedding_Band"]}_First_Metal_Band` : `${ring.options["Wedding_Band"]}_Second_Metal_Band`])?.match(band.Code.split('_')[0])) : ![ "18_YG", "18_RG", "PT_WG" ].includes(band.Code)) ?
                              <Button
                                type={'button'}
                                key={index}
                                buttonType={ring.options[i === 0 ? `${ring.options["Wedding_Band"]}_First_Metal_Band` : `${ring.options["Wedding_Band"]}_Second_Metal_Band`] === band.Code ? "active" : undefined}
                                className={`${classes.button} hk_metal_color_button`}
                                onClick={() => handleMatchingBand(i, band.Code)}
                              >
                                <img className={`${classes.swatchImg} ${classes.swatchImgColor}`}
                                     src={PDPColorImage[band.Code.split("_")[1]]} alt={band.Name}/>
                                <span className={classes.swatchText}>{band.Name}</span>
                              </Button> : null}</Fragment>
                          )
                        })}
                      </div>
                    </Label>
                  </div>
                  <div className={`${classes.items}`}>
                    <Label text={`${i === 0 ? "First" : 'Second'} Band Engraving`}
                           optionsText={<em>(Complimentary)</em>} page={'pdpBuilder'}>
                      <FloatingLabel
                        label={'Your Message'}
                        labelId={`${ring.tabIndex}_${i}_Engraving`}
                        maxLength={18}
                        keyName={`${i === 0 ? "First" : 'Second'}_Band_Engraving`}
                        setRingOptions={setRingOptions}
                        value={ring.options[`${i === 0 ? "First" : 'Second'}_Band_Engraving`]}
                        setIsEngraving={setIsEngraving}
                        options={ring.options}
                        activeIndex={activeIndex}
                        isHandView={ring.isHandLoaded}
                        validationRegex={/^[a-zA-Z0-9 !@#$%^&*(),.<>?;:"'+=\-\/\\]*$/}
                        validationErrorMessage={"Only English letters, numbers, and special characters are allowed."}
                      />
                    </Label>
                  </div>
                </React.Fragment>
              )
            })}
          </> : null}
        </div>
        <div className={classes.buttonWrap}>
          <Button
            type={"button"}
            isLoading={isLoading}
            isDisabled={isLoading}
            buttonType={"btnPrimary"}
            className={`${classes.primaryButton} ${isStuds ? 'rb-track-finalize' : 'rb-track-select-setting'}`}
            data-rb-setting-id={isStuds ? undefined : styleId}
            data-rb-price={ringPrice}
            data-rb-setting-url={isStuds ? undefined : window.location.href}
            data-rb-name={isStuds ? trackingName : undefined}
            data-rb-payload={ctaPayload}
            onClick={isStuds ? handleReviewClick : handleSelectSetting}
          >
            {isStuds ?
                <span className="flex items-center gap-2">
                    <span className="font-semibold text-sm text-white">Finalize Your Design</span>
                    <span>&#8226;</span>
                    <span>{ring.isPriceLoading || !ringPrice || ringPrice <= 0 ? '' : `$${ToLocalStringConvert(+ringPrice)}`}</span>
                </span>:
                <span className="font-semibold text-sm">Select This Setting</span>}
          </Button>
          {/*{Object.keys(diamond.details).length > 0 && !(rpid && uuid) && builder_mode !== CONSTANTS.EDIT && !footer.isRedirectToEdit ? <Button type={'button'} className={classes.backButton}*/}
          {Object.keys(diamond.details).length > 0 && window.location.hash.includes('diamondId') && builder_mode !== CONSTANTS.EDIT && !footer.isRedirectToEdit ?
            <Button
              type={'button'}
              className={classes.backButton}
              isDisabled={isLoading}
              onClick={async () => {
                // navigate(styleId?.includes("RP") ? -2 : -1);
                // window.history.go(styleId?.includes("RP") ? -2 : -(ring.afterDiamondPageCount))
                if (ring.journeyStartedFrom === 'details') {
                  await setBackDiamondDetails(true);
                } else {
                  await setBackToSelectDiamondPage(true);
                }
                if (!footer.isRedirectToEdit) {
                  await setHeaderTabDefault();
                  await setInitialOption();
                  // await setRedirectEditPage(false);
                } else {
                  await setSettingTabIconTrue();
                }
                // await setIsShowFooter(false);
                await toggleScrollTop(true);
                // document.body.classList.add('sticky_filter');
                await (screenManager as any).changeScreen({
                  viewName:     ring.journeyStartedFrom ? ring.journeyStartedFrom : 'diamond',
                  styleId:      null,
                  id:           ring.journeyStartedFrom === 'details' ? (diamond.details.id) : null,
                  searchParams: getBuildSearchParams(window.location),
                })
              }}
            >
              <div className={classes.navigate}>
                {/*<Icon name={"hk_chevron_left"} />*/}
                <span>Back to Diamond Selection</span>
              </div>
            </Button> : null}
          {/*{footer.styleID.includes('RP') && !(rpid && uuid) && builder_mode !== CONSTANTS.EDIT && !footer.isRedirectToEdit ?*/}
          {isSettingPage ?
            (<Button
              type="button"
              className={classes.backButton}
              onClick={() => {
                setInitialOption();
                setScrollTop(true);
                if (!(Object.keys(diamond.details).length > 0)) {
                  setIsShowFooter(false);
                }
                (screenManager as any).changeScreen({
                  viewName:     isListingRing ? 'setting' : isStuds ? 'stud-earrings' : "",
                  styleId:      null,
                  id:           diamond.details.id ? diamond.details.id : null,
                  searchParams: getBuildSearchParams(window.location),
                })
              }}>
             <span
               className={classes.navigate}>{isListingRing ? "Back to Setting Selection" : "Back to Step 1"}</span>
            </Button>) : null
          }
        </div>
      </div>
    </>
  );
};

export default connector(PdpBuilder);
